module.exports = __webpack_public_path__ + "static/media/BU.0111f7b5.svg";